import { useEffect, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import TopRated from "./components/TopRated";
import HiddenGems from "./components/HiddenGems";
import Completed from "./components/Completed";
import WeeklyPick from "./components/WeeklyPick";
import Review from "./components/Review";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;
  return (
    <a
      href="#hero"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-50 inline-flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg shadow-primary-500/30 hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line text-lg" />
    </a>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TopRated />
        <HiddenGems />
        <Completed />
        <WeeklyPick />
        <Review />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}